// extracted by mini-css-extract-plugin
module.exports = {"productAccordionBlock":"styles_productAccordionBlock__Ghxx3","showMoreButton":"styles_showMoreButton__I10Z2"};